import type {
  ReservationAnalyticsEvent,
  ReservationAnalyticsWriter,
} from "./analyticsTypes.ts";
import { getReservationAnalyticsCollectorUrl } from "../firebase/runtimeEndpoints.ts";
import { createReliableAnalyticsDelivery } from "./analyticsReliableDelivery.ts";

export const createReservationAnalyticsPublicCollectorWriter = (
  collectorUrl = getReservationAnalyticsCollectorUrl(),
  fetchImpl: typeof fetch = fetch,
): ReservationAnalyticsWriter => {
  const delivery = createReliableAnalyticsDelivery({
    collectorUrl,
    fetchImpl,
    storageKey: "mintleaf:analytics:traffic:outbox:v1",
  });
  return {
    create: (event: ReservationAnalyticsEvent) =>
      delivery.enqueue(event.eventId, { event }),
  };
};
